import React, { useState } from "react";
import {
  Typography,
  Chip,
  IconButton,
  Tooltip,
  Box,
  Grid
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import screenBg from '../style/img/damier.avif';

const SceneViewer = ({ name, url, rendererId, preview, debug, sx, hideFooter = false }) => {
  const [copied, setCopied] = useState(false);
  // OPUS: localhost renderer displays (e.g. the local aero-controller on :3008)
  // are served over http, not https — derive the scheme from the host so the
  // embed works locally AND on the cloud.
  const proto = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)(:|\/|$)/.test(url || "") ? "http" : "https";
  const link = `${proto}://${url}/?renderer=${rendererId}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Grid  sx={{...sx}}>

      {/* <Rnd
        style={{
          backgroundColor:'#000000', borderRadius:'.5em', padding:'.5em', height:'fit-content' , border:'1px solid #CCCCCC50'
        }}
        // lockAspectRatio='16/9'
        enableResizing={{
          bottomRight: true
        }}
        minWidth={'500px'}
        // size={{ width: this.state.width, height: this.state.height }}
        // position={{ x: this.state.x, y: this.state.y }}
        // onDragStop={(e, d) => {
        //   this.setState({ x: d.x, y: d.y });
        // }}
        // onResizeStop={(e, direction, ref, delta, position) => {
        //   this.setState({
        //     width: ref.style.width,
        //     height: ref.style.height,
        //     ...position,
        //   });
        // }}
      > */}
        <Box sx={{backgroundColor: hideFooter ? 'transparent' : '#000000', borderRadius:'.5em', padding: hideFooter ? 0 : '.4em', height:'fit-content' , border:'0px solid #CCCCCC50'}}>

          <div style={{ width: '100%', position: 'relative', aspectRatio: '16/9', borderRadius: hideFooter ? 'var(--r-md)' : 0, overflow: hideFooter ? 'hidden' : 'visible' }}>
            <iframe
              src={`${proto}://${url}/?renderer=${rendererId}${preview ? '' : ''}&debug=${debug}`}
              style={{
                border: "none",
                width: '100%',
                height: '100%',
                position: 'absolute', // Allows it to fill the container
                top: 0,
                left: 0,
                backgroundImage: `url(${screenBg})`, // Set the background image using imported image
                backgroundSize: 'cover', // Cover the entire area
                backgroundPosition: 'center', // Center the image
              }}
              title="Confidence feed"
            />
          </div>

          {!hideFooter && <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent:'center', alignItems:'center', mt:1}}>
            <Typography sx={{color:'#777'}} className="drag-handle">{name}</Typography>
            <Chip
              sx={{
                border: "1px solid #cccccc20",
                fontSize: "1em",
                backgroundColor: "#cccccc15",
                color: "FFFFFF95",
              }}
              label={link}
              onDelete={handleCopy}
              deleteIcon={
                <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
                  <IconButton size="small" sx={{ color: "gray" }}>
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              }
            />
          </Box>}

        </Box>
      {/* </Rnd> */}

    </Grid>
  );
};

export default SceneViewer;
